import styled from 'styled-components';
import AppCSS from '../../utils/styled';
import { DEFAULT_BUTTON_WIDTH, HEADER_BUTTON_HEIGHT } from '../../utils/styled/dimensions';

export const Components = {
  Container: styled.div`
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 16px 24px;
    background-color: ${AppCSS.colors.utility.screenBackground};
    gap: 20px;
    min-width: fit-content;
    & > * {
      flex-shrink: 0;
    }
  `,
  StatusBar: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 16px;
    ${AppCSS.radiuses.small};
    background-color: ${AppCSS.colors.white};
    ${AppCSS.boxShadows.block};
  `,
  StatusText: styled.span`
    ${AppCSS.fonts.label14Medium};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  PrimaryButton: styled(AppCSS.buttonStyles.PrimaryButtonStyle)`
    width: ${DEFAULT_BUTTON_WIDTH}px;
    min-width: ${DEFAULT_BUTTON_WIDTH}px;
    height: ${HEADER_BUTTON_HEIGHT}px;
    min-height: ${HEADER_BUTTON_HEIGHT}px;
  `,
  BatchToolbar: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px 16px;
    ${AppCSS.radiuses.small};
    background-color: ${AppCSS.colors.white};
    ${AppCSS.boxShadows.block};
  `,
  BatchToolbarLeft: styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  `,
  BatchToolbarRight: styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  BatchProgressText: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.greys.prettyDark};
  `,
  TableWrapper: styled.div`
    width: 100%;
    ${AppCSS.radiuses.small};
    background-color: ${AppCSS.colors.white};
    ${AppCSS.boxShadows.block};
    overflow: hidden;
    flex-shrink: 0;
  `,
  RowTitle: styled.span`
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  RowCaption: styled.span`
    ${AppCSS.fonts.label10Regular};
    color: ${AppCSS.colors.greys.prettyDark};
  `,
  StatusCellContent: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    min-width: 120px;
  `,
  StatusChip: styled.span<{ tone: 'default' | 'progress' | 'success' | 'error' | 'muted' }>`
    display: inline-flex;
    align-items: center;
    padding: 2px 10px;
    ${AppCSS.radiuses.rounded};
    ${AppCSS.fonts.label10Bold};
    white-space: nowrap;
    color: ${({ tone }) => {
      switch (tone) {
        case 'success':
          return AppCSS.colors.white;
        case 'error':
          return AppCSS.colors.white;
        case 'progress':
          return AppCSS.colors.white;
        default:
          return AppCSS.colors.blues.veryDark;
      }
    }};
    background-color: ${({ tone }) => {
      switch (tone) {
        case 'success':
          return AppCSS.colors.blues.strong;
        case 'error':
          return AppCSS.colors.red;
        case 'progress':
          return AppCSS.colors.orange;
        case 'muted':
          return AppCSS.colors.greys.light;
        default:
          return AppCSS.colors.greys.light;
      }
    }};
  `,
  EmptyState: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    ${AppCSS.fonts.label14Regular};
    color: ${AppCSS.colors.greys.prettyDark};
  `,
};
